import React, { useState } from 'react';
import PokerTable from './PokerTable';
import { newTable } from './api';
import Loading from './Loading';
import Modal from 'react-modal';

export default function() {
  const isMobile = window.innerWidth < 768;
  const [page, setPage] = useState<'loading' | 'home' | 'game'>('loading');
  let content;
  if (page === 'loading') {
    // disable new games
    setPage('home');
    // if (window.location.pathname.startsWith('/g/')) {
    //   isMobile ? setPage('home') : setPage('game');
    // } else {
    //   setPage('home');
    // }
    content = <Loading />;
  } else if (page === 'home') {
    content = (
      <div className="home">
        <div className="title">
          Enjoy some facetime with friends and
          <br /> play a game of poker while social distancing
        </div>
        <br />
        <br />
        <img alt="aces animation" src="/assets/aces.gif" />
        <br />
        <br />
        {isMobile ? (
          <div className="title">
            Pokerona is not available on mobile.
            <br /> Try on a desktop computer.
          </div>
        ) : (
          <button
            disabled={true}
            //disabled={isMobile}
            onClick={async () => {
              try {
                const { tableId } = await newTable();
                window.location.pathname = `/g/${tableId}`;
              } catch (e) {
                console.error('error', e);
                alert('Oops. Something went wrong. Try again later.');
              }
            }}
          >
            Start new game
          </button>
        )}
        <br />
        <small>(It's free!)</small>
        <br />
        {!isMobile && (
          <div>
            If you need to join a table, ask the host to share the invite link
          </div>
        )}
      </div>
    );
  } else if (page === 'game') {
    content = <PokerTable />;
  } else {
    content = 'null';
  }

  return (
    <>
      <Modal
        portalClassName={'help-modal'}
        isOpen={true}
        //onRequestClose={() => this.setState({ isHelpModalOpen: false })}
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: isMobile ? '300px' : '560px',
            textAlign: 'center',
            fontSize: isMobile ? '20px' : '32px',
          },
        }}
      >
        Pokerona is temporarily unavailable. <br />
        <br />
        Click{' '}
        <a
          href="mailto:sharath.prabhal@gmail.com?subject=Notify Pokerona"
          target="_blank"
        >
          here
        </a>{' '}
        if you want to be notified when its back online.
      </Modal>
      <header>
        <div>
          <a className="logo" href="/">
            P<small>okerona</small>
          </a>
        </div>
        <div></div>
      </header>
      <main className="main-content">{content}</main>
      <footer>
        <span>
          A{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://sharathprabhal.com"
          >
            Sharath Prabhal
          </a>{' '}
          experiment
        </span>
      </footer>
    </>
  );
}
